<template>
	<div style="height: 500px;">
		<div class="block" style="margin-bottom: 10px;">
			<transition name="el-zoom-in-top">
				  <el-carousel :interval="6000" height="500px">
				    <el-carousel-item v-for="item in bigScreen.images" :key="item" :name="item.name">
					<div class="frontHomeBanner">
					</div>	
					<img style="width:100%;height:100%;" :src="item.url"/>
				    </el-carousel-item>
				  </el-carousel>
			</transition>
			<!-- <el-button @click="show2 = !show2">Click Me</el-button> -->
		</div>
	</div>
</template>
<script>
export default {
	data () {
	    return {
			show2: true,
			
			bigScreen: {
				images: [
				{
					name: '1',
					url: './Homebanner/banner_01.jpg'
				},
				{
					name: '2',
					url: './Homebanner/banner_02.jpg'
				},
				{
					name: '3',
					url: './Homebanner/banner_03.jpg'
				},
				{
					name: '4',
					url: './Homebanner/banner_04.jpg'
				}]
			}
		}
		},
		created () {
		},
		methods: {
			},
		computed: {
				}
}
</script>

<style>
	.frontHomeBanner{
		height: 40px;
		width: 100%;
		background-color: #218DD1;
		float: left;
		position: absolute;
		text-align: center;
		/* line-height: 300px; */
		opacity: 0.50;
	}
</style>
